import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { defaultColors } from 'root/src/client/web/commonStyles'

const { viewFieldTheme } = formModuleLenses

export default (state, { moduleId }) => viewFieldTheme(
	moduleId, moduleDescriptions,
) || defaultColors
